import React, { useState } from 'react'

import { MdDownload } from "react-icons/md"
import { BsApple, BsWindows  } from "react-icons/bs"
import { AiFillAndroid } from "react-icons/ai"

export default function InstallButton(
  {
    text,
    backgroundColor,
    backgroundColorHover,
    color,
    colorHover,
    iconSize=25,
    iconType="download",
    textSize=16,
    onClick
  }) {
    const [backgroundColorState, setBackgroundColorState] = useState(backgroundColor)
    const [colorState, setColorState] = useState(color)

    let icon = null
    if (iconType === "android"){
      icon = <AiFillAndroid size={iconSize} color={colorState} />
    }else if (iconType === "apple"){
      icon = <BsApple size={iconSize} style={{marginRight:8}} color={colorState} />
    }else if (iconType === "windows"){
      icon = <BsWindows size={iconSize} style={{marginRight:8}} color={colorState} />
    } else{
      icon = <MdDownload size={iconSize} style={{marginRight:8}} color={colorState} />
    }

    const handleMouseEnter = (e) => {
      setBackgroundColorState(backgroundColorHover)
      setColorState(colorHover)
    }

    const handleMouseLeave = (e) => {
      setBackgroundColorState(backgroundColor)
      setColorState(color)
    }

    return (
      <div
        className="rounded shadow text-center align-self-center p-3"
        style={{
          background:backgroundColorState,
          color:colorState,
          cursor:"pointer",
          width:"fit-content",
          height:"fit-content"
        }}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
          <div>
          {icon}
          </div>
          <div>
          <span style={{fontSize:textSize}}>{text}</span>
          </div>
      </div>
    )
}